import { Card, Checkbox, Col, Form, Input, Row, Typography } from "antd";
import React, { useState, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
const { Title } = Typography;

const Authorization = ({ getChildData, patientDetailsFMLA }) => {
  const { t, i18n } = useTranslation();
  const [signatureActive, setSignatureActive] = useState(false);
  const callparent = (e, name) => {
    getChildData(e, name);
  };
  
  const validateAuthorization = useCallback((_, value) => {
    if (value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("patientDetailsFMLS:please_accept_the_authorization")));
  }, [t]);
  
  const validateTermsCondition = useCallback((_, value) => {
    if (value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("patientDetailsFMLS:please_accept_the_term_and_condition")));
  }, [t]);
  
  const validationRules = useMemo(() => ({
    authorization: [{ validator: validateAuthorization }],
    signature: [{ required: true, message: t("patientDetailsFMLS:please_enter_signature") }],
    termsCondition: [{ validator: validateTermsCondition }]
  }), [t, validateAuthorization, validateTermsCondition]);

  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("patientDetailsFMLS:authorization")}
        </Title>
      }
    >
      <Row gutter={[0, 10]} className="px-1 md:px-6">
        <Col span={24}>
          <Form.Item
            name="Authorization1"
            valuePropName="checked"
            onChange={(e) => callparent(e.target.checked, "Authorization1")}
            checked={patientDetailsFMLA.Authorization1}
            className="checkbox-align-top"
            rules={validationRules.authorization}
          >
            <Checkbox className="font-medium">
              {t("patientDetailsFMLS:auth_desc_1")}
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="Authorization2"
            valuePropName="checked"
            checked={patientDetailsFMLA.Authorization2}
            onChange={(e) => callparent(e.target.checked, "Authorization2")}
            className="checkbox-align-top"
            rules={validationRules.authorization}
          >
            <Checkbox className="font-medium">
              {t("patientDetailsFMLS:auth_desc_2")}
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="Authorization3"
            valuePropName="checked"
            checked={patientDetailsFMLA.Authorization3}
            onChange={(e) => callparent(e.target.checked, "Authorization3")}
            className="checkbox-align-top"
            rules={validationRules.authorization}
          >
            <Checkbox className="font-medium">
              {t("patientDetailsFMLS:auth_desc_3")}
            </Checkbox>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            wrapperCol={{ lg: 12 }}
            onChange={(e) =>
              callparent(e.target.value, "Authorizationsignature")
            }
            name="Authorizationsignature"
            label={t("patientDetailsFMLS:sign_label")}
            className={`signature ${
              patientDetailsFMLA.Authorizationsignature != "" || signatureActive
                ? ""
                : "auth-watermark"
            }`}
            rules={validationRules.signature}
          >
            <Input
              maxLength={100}
              onBlur={() => {
                setSignatureActive(false);
              }}
              onFocus={() => {
                setSignatureActive(true);
              }}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="Authorization4"
            checked={patientDetailsFMLA.Authorization4}
            valuePropName="checked"
            onChange={(e) => callparent(e.target.checked, "Authorization4")}
            className="checkbox-align-top"
            rules={validationRules.termsCondition}
          >
            <Checkbox className="font-medium">
              {t("patientDetailsFMLS:auth_desc_4")}
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};
export default Authorization;
